import { create } from 'zustand'

import { fetchUserCollectedStarsStatisticApi, getQuestsApi } from '@api'

import { createSelectors, Mapper } from './helpers'

export interface CollectedStarsStatisticBackend {
  collection_date: string
  stars_count: number
}

export interface CollectedStarsStatistic {
  collectionDate: string
  starsCount: number
}

const CollectedStarsMapper: Mapper<
  CollectedStarsStatisticBackend,
  CollectedStarsStatistic
> = {
  mapFromBackend: function (data) {
    return {
      collectionDate: data.collection_date,
      starsCount: data.stars_count,
    }
  },
  mapToBackend(data) {
    return {
      collection_date: data.collectionDate,
      stars_count: data.starsCount,
    }
  },
}

interface StatisticState {
  isLoading: boolean
  isError: boolean
  collectedStarsStatistic: CollectedStarsStatistic[]
  actions: {
    fetchCollectedStarsStatistic: () => void
  }
}

const useStatisticStoreBase = create<StatisticState>((set, get) => ({
  isLoading: true,
  isError: false,
  collectedStarsStatistic: [],
  actions: {
    fetchCollectedStarsStatistic: async () => {
      set(() => ({ isLoading: true }))

      const { data, ok } = await fetchUserCollectedStarsStatisticApi()
      if (ok && data) {
        const mapped = data.map((item) =>
          CollectedStarsMapper.mapFromBackend(item)
        )
        set(() => {
          return {
            collectedStarsStatistic: mapped,
          }
        })
      }

      set(() => ({
        isLoading: false,
      }))
    },
  },
}))

export const useStatisticActions = () =>
  useStatisticStoreBase((state) => state.actions)

export const useStatistic = createSelectors(useStatisticStoreBase)
